import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { videos } from "@/mocks/videos";

export default function CategoryEntry() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-50">
      <div className="flex items-end justify-between mb-6 md:mb-8 flex-wrap gap-3">
        <div>
          <h2 className="font-heading font-black text-2xl md:text-3xl text-foreground-950">
            内容分类
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            三大板块，快速找到你想看的内容
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {categories.map((cat) => {
          const count = videos.filter((v) => v.category === cat.slug).length;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative block h-52 md:h-60 rounded-lg overflow-hidden cursor-pointer"
            >
              <img
                src={cat.cover}
                alt={`${cat.name} - 日皮视频`}
                title={`${cat.name} 视频分类`}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/10" />
              <div className="relative h-full p-5 flex flex-col justify-end">
                <span className="w-10 h-10 rounded-md bg-primary-500 flex items-center justify-center mb-3">
                  <i className={`${cat.icon} text-background-50 text-xl`} />
                </span>
                <h3 className="font-heading font-bold text-xl text-background-50">
                  {cat.name}
                </h3>
                <p className="mt-1 text-xs text-background-300 line-clamp-2">
                  {cat.description}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-primary-300 text-sm font-medium">
                  {count} 个视频 <i className="ri-arrow-right-line" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}